import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Publikasi")
], -1)
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_9 = { class: "breadcrumb-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("List Publikasi")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item active" }, " Publikasi ", -1)
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "container-fluid" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "card-header p-2" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Edit Publikasi")
], -1)
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "form-horizontal" }
const _hoisted_18 = { class: "form-group row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputName",
  class: "col-sm-2 col-form-label"
}, "Judul", -1)
const _hoisted_20 = { class: "col-sm-10" }
const _hoisted_21 = { class: "form-group row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputName",
  class: "col-sm-2 col-form-label"
}, "Author", -1)
const _hoisted_23 = { class: "col-sm-10" }
const _hoisted_24 = { class: "form-group row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputName",
  class: "col-sm-2 col-form-label"
}, "Tanggal Publikasi", -1)
const _hoisted_26 = { class: "col-sm-10" }
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputEmail",
  class: "col-sm-2 col-form-label"
}, "Isi Singkat (Max 100 chars)", -1)
const _hoisted_29 = { class: "col-sm-10" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_32 = { class: "form-group row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputEmail",
  class: "col-sm-2 col-form-label"
}, "Isi Lengkap", -1)
const _hoisted_34 = { class: "col-sm-10" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_37 = { class: "form-group row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputEmail",
  class: "col-sm-2 col-form-label"
}, "Foto", -1)
const _hoisted_39 = { class: "col-sm-10" }
const _hoisted_40 = { class: "form-group row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputName",
  class: "col-sm-2 col-form-label"
}, "Youtube", -1)
const _hoisted_42 = { class: "col-sm-10" }
const _hoisted_43 = { class: "form-group row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputEmail",
  class: "col-sm-2 col-form-label"
}, "Headline", -1)
const _hoisted_45 = { class: "col-sm-10" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Tidak", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Ya", -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { class: "form-group row" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputEmail",
  class: "col-sm-2 col-form-label"
}, "Status", -1)
const _hoisted_51 = { class: "col-sm-10" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Aktif", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Tidak Aktif", -1)
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = { class: "form-group row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputEmail",
  class: "col-sm-2 col-form-label"
}, "Urutan", -1)
const _hoisted_57 = { class: "col-sm-10" }
const _hoisted_58 = { class: "form-group row" }
const _hoisted_59 = { class: "offset-sm-2 col-sm-10" }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_QuillEditor = _resolveComponent("QuillEditor")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_router_link, { to: "/publication" }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _hoisted_11
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("form", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.name) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "inputName",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, _ctx.name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.author) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "inputName",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, _ctx.author]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.date) = $event)),
                    type: "date",
                    class: "form-control",
                    id: "inputName",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, _ctx.date]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("textarea", {
                    maxlength: "100",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.short_content) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.short_content]
                  ])
                ])
              ]),
              _hoisted_30,
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_QuillEditor, {
                    toolbar: "full",
                    theme: "snow",
                    content: _ctx.full_content,
                    "onUpdate:content": _cache[4] || (_cache[4] = $event => ((_ctx.full_content) = $event)),
                    contentType: "html"
                  }, null, 8, ["content"])
                ])
              ]),
              _hoisted_35,
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("input", {
                    type: "file",
                    onChange: _cache[5] || (_cache[5] = (...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                    class: "form-control",
                    id: "inputEmail",
                    placeholder: "Jawaban"
                  }, null, 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.youtube) = $event)),
                    type: "url",
                    class: "form-control",
                    id: "inputName",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, _ctx.youtube]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.headline) = $event)),
                    class: "form-control"
                  }, _hoisted_48, 512), [
                    [_vModelSelect, _ctx.headline]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.status) = $event)),
                    class: "form-control"
                  }, _hoisted_54, 512), [
                    [_vModelSelect, _ctx.status]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _withDirectives(_createElementVNode("input", {
                    min: "1",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.urutan) = $event)),
                    type: "number",
                    class: "form-control",
                    id: "inputEmail",
                    placeholder: "Urutan"
                  }, null, 512), [
                    [_vModelText, _ctx.urutan]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.submit && _ctx.submit(...args))),
                    class: "btn btn-primary"
                  }, " Submit ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}